export default __webpack_public_path__ + "static/media/placeholder_store03-en-web.156f7fc5.png";